module.exports = __webpack_public_path__ + "static/media/dulichDetail.6a40ecbd.png";